import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-[1rem] right-[1rem] p-1 bg-background rounded-full overflow-hidden z-10" }
const _hoisted_2 = { class: "ml-2 tabular-nums flex flex-row items-center gap-1 uppercase tracking-wider" }
const _hoisted_3 = {
  key: 0,
  class: "sr-only"
}

import PartySocket from 'partysocket'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThePresenceIndicator',
  setup(__props) {

const colorSet = {
  live: {
    badge:
      'light:border-red-800 dark:border-red-400 light:shadow-red-400 dark:shadow-red-800 text-red-400 light:text-red-800',
    block: 'light:bg-red-800 dark:bg-red dark:shadow-red-800',
  },
  default: {
    badge:
      'light:border-green-800 dark:border-green-400 light:shadow-green-400 dark:shadow-green-800 opacity-60 hover:opacity-100 focus:opacity-100',
    block: 'light:bg-green-800 dark:bg-green dark:shadow-green-800',
  },
}

const status = ref<keyof typeof colorSet>('default')
const count = ref<null | number>(null)

const LiveWrapper = defineComponent({
  setup (_props, { slots }) {
    return () =>
      h(
        'a',
        {
          'href': 'https://twitch.tv/danielroe',
          'target': '_blank',
          'rel': 'noopener noreferrer',
          'aria-label': 'Live now on Twitch (opens in new tab)',
          'class': 'rounded-full f-ring',
        },
        slots,
      )
  },
})

const PresenceWrapper = defineComponent({
  setup (_props, { slots }) {
    return () =>
      h(
        'span',
        {
          title: count.value ? `${count.value} viewers on website` : undefined,
        },
        slots,
      )
  },
})

if (import.meta.client) {
  let partySocket: PartySocket
  onNuxtReady(() => {
    partySocket = new PartySocket({
      host: import.meta.dev ? 'localhost:1999' : 'v.danielroe.partykit.dev',
      room: 'site',
    })

    partySocket.onmessage = evt => {
      const data = evt.data as string
      const [type, value] = data.split(':')
      if (!value) return
      switch (type) {
        case 'connections':
          count.value = parseInt(value)
          break

        case 'status':
          if (value in colorSet) status.value = value as keyof typeof colorSet
          break
      }
    }
  })

  onBeforeUnmount(() => partySocket?.close())
  onDeactivated(() => partySocket?.close())
  onActivated(() => partySocket?.reconnect())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(status) === 'live' ? _unref(LiveWrapper) : _unref(PresenceWrapper)), {
      class: _normalizeClass(["pl-2 pr-2 py-1 rounded-full flex flex-row items-center shadow tracking-none border-1 text-xs transition-opacity", colorSet[_unref(status)].badge])
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["rounded-full inline-block h-2 w-2 motion-safe:animate-pulse shadow", colorSet[_unref(status)].block])
        }, null, 2),
        _createElementVNode("span", _hoisted_2, [
          (_unref(status) === 'live')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" live now ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(count) || ' ') + " ", 1),
                (_unref(count))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "viewers on website"))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _cache[0] || (_cache[0] = _createTextVNode(" ​ ", -1))
      ]),
      _: 1
    }, 8, ["class"]))
  ]))
}
}

})